import trackEvent from "@/utils/trackEvent";
export default function initTrackEvent(Vue) {
  Vue.prototype.$trackEvent = trackEvent;
}
